export default "/images/vendor/flag-icon-css/flags/4x3/ps.svg?77489c5e7455703ed84f5548c3addbb3";